import React from "react";
import { useRef, useEffect } from "react";
import Navbar from "../components/Navbar";
import { Box, Typography, Button } from "@mui/material";
import Vector from "../components/img/icon/Vector.png";
import img1 from "../components/img/img1.png";
import img2 from "../components/img/img2.png";
import img3 from "../components/img/img3.png";
import img4 from "../components/img/img4.png";
import Vector1 from "../components/img/Vector1.png";
import Vector2 from "../components/img/Vector2.png";
import Vector3 from "../components/img/Vector3.png";
import Vector4 from "../components/img/Vector4.png";
import English from "../components/img/English.png";
import calculate from "../components/img/calculate.png";
import eco from "../components/img/eco.png";
import experiment from "../components/img/experiment.png";
import lang from "../components/img/Lang.png";

import li_icon from "../components/img/icon/li_icon.png";
import Courses from "../components/sections/Courses.jsx";

import ExtraActivities from "../components/home-compo/ExtraActivities.jsx";
import ReachOut from "../components/home-compo/ReachOut.jsx";
import Footer from "../components/common-components/Footer.jsx";
import Classroom from "../components/home-compo/Classroom.jsx";
import DirectorMessage from "../components/home-compo/DirectorMessage.jsx";
import Testimonials from "../components/home-compo/Testimonials.jsx";
import CourseCard from "../components/common-components/CourseCard.jsx";
import Whatsapp from "../components/common-components/Whatsapp.jsx";

import "../styles/pages-style/Home.css";
import "../styles/pages-style/Mob-view-Home.css";
import { useLocation, useNavigate, NavLink } from "react-router-dom";

const InfoBox = ({ title, description, path }) => (
  <Box className="info-box" sx={{ backgroundColor: " #ffffff" }}>
    <Box className="info-box-icon">
      <img src={path} alt="" />
    </Box>
    <Box className="info-box-content">
      <Typography className="info-box-title">{title}</Typography>
      <Typography className="info-box-description">{description}</Typography>
    </Box>
  </Box>
);
const CourseStructureCard = ({ Bold, Normal, description }) => (
  <Box className="course-structure-card">
    <Box className="course-structure-card-box">
      <Typography className="course-structure-card-bold">{Bold}</Typography>
      <Typography className="course-structure-card-normal">{Normal}</Typography>
    </Box>
    <Typography className="course-structure-card-description">
      {description}
    </Typography>
  </Box>
);

const SubjectCard = ({ Image, Content, height, width, imgW, imgH }) => (
  <Box
    className="subject-card"
    style={{ width: width, height: height }} // Dynamic values via inline style
  >
    <Box>
      <Typography className="subject-card-content">{Content}</Typography>
      <Box
        className="subject-card-image-container"
        style={{ width: imgW, height: imgH }}
      >
        <img src={Image} alt="" />
      </Box>
    </Box>
  </Box>
);
const InfoCard = ({ title, points, width, height }) => (
  <Box className="info-card" style={{ width: width, height: height }}>
    <Typography variant="h6" className="info-card-title">
      {title}
    </Typography>

    {/* Purple line below the title */}
    <Box className="info-card-line" />

    <ul className="info-card-list">
      {points.map((point, index) => (
        <li key={index} className="info-card-list-item">
          <img src={li_icon} alt="icon" />
          <Typography variant="body2" className="info-card-list-text">
            {point}
          </Typography>
        </li>
      ))}
    </ul>
  </Box>
);
const cardData = [
  {
    title: "Additional Features",
    height: "49vh",
    width: "20vw",
    points: [
      "Periodic tests and performance tracking.",
      "Interactive teaching methods using digital tools and activities.",
      "Study planning and time management guidance for exams.",
    ],
  },
  {
    title: "Why Choose Our Program?",
    height: "56vh",
    width: "20vw",
    points: [
      "Experienced Faculty: Teachers with expertise in subject-specific teaching.",
      "Individualized Attention: Small group sizes to address every student's needs.",
      "Comprehensive Resources: Access to notes, worksheets, and video tutorials.",
      "Exam-Ready Preparation: Emphasis on board and competitive exam success.",
    ],
  },
  {
    title: "Learning Modes",
    height: "49vh",
    width: "20vw",
    points: [
      "Regular Classes: Scheduled sessions for complete syllabus coverage.",
      "Doubt-Solving Sessions: Dedicated hours to clarify concepts.",
      "Crash Courses: Quick revisions before exams.",
      "Workshops: Skill-building sessions for specific topics like essay writing, map work, and more.",
    ],
  },
];

const Home = () => {
  const testimonialsRef = useRef(null);
  const location = useLocation();
  const navigate = useNavigate();

  const enrollClick = () => {
    navigate("/ContactUs");
  };
  useEffect(() => {
    if (location.state?.scrollTo) {
      const target = document.getElementById(location.state.scrollTo);
      if (target) {
        setTimeout(() => {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }, 100); // Small delay ensures the element is loaded
      }
    }
  }, [location]);

  const scrollToTestimonials = () => {
    if (testimonialsRef.current) {
      testimonialsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Box className="root-container" sx={{ overflowX: "hidden" }}>
      <Navbar scrollToTestimonials={scrollToTestimonials} />
      <Whatsapp />

      <Box className="global-container">
        <Box className="Hero-container">
          <Box className="left-section">
            {/* Heading */}
            <Typography className="heading">
              Building Bridges To Confidence And Success
            </Typography>

            {/* Body Text */}
            <Typography className="body-text">
              At Hrishi’s Holistic Hub, we are dedicated to empowering students
              to excel not only in academics but also in life. With personalized
              guidance, expert educators, and a focus on holistic development,
              we pave the way for success—one step at a time. Join us on this
              journey of growth, where every student discovers their true
              potential!
            </Typography>

            {/* Button */}
            <NavLink className="appointment-link" to="/ContactUs">
              <Button className="appointment-btn">
                <img src={Vector} alt="" />
                Book an Appointment
              </Button>
            </NavLink>
          </Box>
          <Box className="image-grid">
            <Box component="img" src={img1} alt="" className="image1" />
            <Box component="img" src={img2} alt="" className="image2" />
            <Box component="img" src={img3} alt="" className="image3" />
            <Box component="img" src={img4} alt="" className="image4" />
          </Box>
        </Box>

        <Box className="second-section">
          <Box className="left-box">
            <Typography className="section-title">
              Why Choose Our Program?
            </Typography>
            <Box className="info-box-grid">
              <InfoBox
                title="Experienced Faculty"
                description="Teachers with expertise in subject-specific teaching."
                path={Vector1}
              />
              <InfoBox
                title="Individual Attention"
                description="Small group sizes to address every student's needs."
                path={Vector2}
              />
              <InfoBox
                title="Comprehensive Resources"
                description="Access to notes, worksheets, and video tutorials."
                path={Vector3}
              />
              <InfoBox
                title="Exam-ready Preparation"
                description="Emphasis on board and competitive exam success."
                path={Vector4}
              />
            </Box>
          </Box>

          <Box className="right-box">
            <Typography className="welcome-text">Welcome To</Typography>
            <Typography className="welcome-text highlight">
              {" "}
              Hrishi’s Holistic Hub
            </Typography>
            <Typography className="description">
              Where learning meets growth and empowerment! Founded with a vision
              to provide more than just academic excellence, Hrishi’s Holistic
              Hub is a nurturing space where students thrive academically,
              emotionally, and socially. We believe that every child has the
              potential to excel when given the right guidance, tools, and
              encouragement. Our mission is to foster a love for learning while
              developing the skills and confidence students need to succeed in
              today’s world. At Hrishi’s Holistic Hub, we combine personalized
              teaching with innovative techniques to ensure each student reaches
              their full potential. Join us at Hrishi’s Holistic Hub, where
              education is more than grades—it’s about building a foundation for
              lifelong success. Let’s grow together!
            </Typography>
          </Box>

          <Box className="course-structure">
            <Typography className="course-title">Course Structure</Typography>
            <CourseStructureCard
              Bold="1-10"
              Normal="Grade Levels"
              description="Separate batches for Grades 1-10, ensuring age-appropriate content"
            />
            <CourseStructureCard
              Bold="2-5per week"
              Normal="Class Frequency"
              description="Flexible options for 2-5 classes per week. "
            />
            <CourseStructureCard
              Bold="1 hour"
              Normal="Duration"
              description="1-hour sessions, with extended workshops on special topics"
            />
            <CourseStructureCard
              Bold="Modes"
              Normal="availability"
              description="Online and in-person classes available."
            />
          </Box>
          <Box className="subjects-offered">
            <Typography className="course-title">Subjects Offered</Typography>
            <Box className="subject-box">
              <Box className="subject-grid">
                <SubjectCard
                  className="top-subject"
                  Image={English}
                  Content={"English"}
                  height={"46vh"}
                  width={"25vw"}
                  imgw={"151px"}
                  imgh={"151px"}
                />
                <Box className="subject-cards-grid">
                  <SubjectCard
                    Image={calculate}
                    Content={"Mathematics"}
                    height={"20Vh"}
                    width={"10.4vw"}
                    imgw={"115px"}
                    imgH={"115px"}
                  />
                  <SubjectCard
                    Image={experiment}
                    Content={"Science"}
                    height={"20Vh"}
                    width={"10.4vw"}
                    imgw={"115px"}
                    imgH={"115px"}
                  />
                  <SubjectCard
                    Image={lang}
                    Content={"Languages"}
                    height={"20Vh"}
                    width={"10.4vw"}
                    imgw={"115px"}
                    imgH={"115px"}
                  />
                  <SubjectCard
                    Image={eco}
                    Content={"Social Studies"}
                    height={"20Vh"}
                    width={"10.4vw"}
                    imgw={"115px"}
                    imgH={"115px"}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>

        {/* third section */}
        <Box className="container">
          <Box className="card-container">
            {cardData.map((data, index) => (
              <Box
                className={`card ${index === 1 ? "second-card" : ""}`}
                key={index}
              >
                <InfoCard
                  title={data.title}
                  points={data.points}
                  height={data.height}
                  width={data.width}
                />
              </Box>
            ))}
          </Box>

          <Button
            variant="contained"
            className="enroll-button"
            onClick={() => {
              enrollClick();
              window.scrollTo({ top: 0 });
            }}
          >
            Enroll Now
          </Button>

          <Typography className="enroll-text">
            Ensure your child excels academically with our structured and
            student-focused program. Limited seats available! Contact us at +91
            8766551964 for more details and enrollments.
          </Typography>
        </Box>

        {/* forth section  */}
        <Box className="main-container">
          <Courses />
        </Box>

        {/* Fifth Section */}
        <Box className="fifth-section">
          <Box className="fifth-section-text">
            <Typography variant="h6">
              Enroll today and watch your child’s creativity soar!
            </Typography>
          </Box>
          <Button
            onClick={() => {
              enrollClick();
              window.scrollTo({ top: 0 });
            }}
            variant="contained"
            className="fifth-section-button"
          >
            Enroll Now
          </Button>
        </Box>

        {/* sixth section    */}
        <Box className="course-card-container">
          <CourseCard />
        </Box>

        {/* seventh section */}
        <Box ref={testimonialsRef} className="testimonials-container-main">
          <Testimonials />
        </Box>

        {/* eighth section  */}
        {/* Director Message Section */}
        <Box className="director-message-container">
          <DirectorMessage />
        </Box>

        {/* Ninth Section */}
        <Box className="ninth-section-container">
          <Classroom />
          <ExtraActivities />
        </Box>

        {/* Contact Form Section */}
        <Box className="contact-form">
          <div id="reachOut">
            <ReachOut />
          </div>
        </Box>
      </Box>
      <Box className="footer-class" sx={{ width: "98.3%" }}>
        <Footer scrollToTestimonials={scrollToTestimonials} />
      </Box>
    </Box>
  );
};

export default Home;
